 import { getAllCategories } from "backend/queries";
 import wixLocation from 'wix-location';
 import wixAnimations from 'wix-animations';
 import wixWindow from 'wix-window';

 let menuTimeLine = wixAnimations.timeline();

 $w.onReady(function () {
     try {
         headerDropDownHandler();
         menuToggle();
         getAllCategories()
             .then(categories => {
                 $w('#categoriesHeaderRepeater').data = categories;
                 $w('#mobileCategoriesRepeater').data = categories;
                 console.log(categories)
             });
         $w('#mobileCategoriesRepeater').onItemReady(($item, itemData) => {
             $item("#repeatedCategoryMobileButton").label = itemData.name;
             $item("#repeatedCategoryMobileButton").link = itemData.pageUrl;
         })
     } catch (error) {
         console.log(error)
     }

     initMasterSearch();
 });

 function menuToggle() {

     let defualtDropDownIconUrl = "https://static.wixstatic.com/shapes/996a4e_e95c51eb6dc54e22ae5b6686b7d0afc2.svg"; //Arrow Down
     let expandedDropDownIconUrl = "https://static.wixstatic.com/shapes/996a4e_c7bb5734f5734e8dbd0f63be7ac7f15b.svg"; //Arrow Up
     const mobileDropdownToggler = $w('#menuToggleButton');
     const mobileDropdown = $w('#mobilemenu');
     menuTimeLine.add(mobileDropdown, { opacity: 1.0, duration: 300 })
         .onReverseComplete(() => mobileDropdown.collapse())

     $w('#categoriesBtnM').icon = defualtDropDownIconUrl;
     mobileDropdownToggler.icon = defualtDropDownIconUrl;

     mobileDropdownToggler.onClick(async () => {
         if (mobileDropdown.collapsed) {
             await mobileDropdown.expand();
             mobileDropdownToggler.icon = expandedDropDownIconUrl;
             menuTimeLine.play();
         } else {
             mobileDropdownToggler.icon = defualtDropDownIconUrl;
             menuTimeLine.reverse();
         }

     })

     $w('#categoriesBtnM').onClick(() => {

         if ($w('#categoriesBtnM').icon === defualtDropDownIconUrl) {
             $w('#categoriesMobileRepeaterCont').expand();
             $w('#categoriesBtnM').icon = expandedDropDownIconUrl;
         } else {

             $w('#categoriesMobileRepeaterCont').collapse();
             $w('#categoriesBtnM').icon = defualtDropDownIconUrl;
         }
     })

     $w('#goBackButton').onClick(() => {
         $w('#categoriesMobileRepeaterCont').collapse();
         $w('#categoriesBtnM').icon = defualtDropDownIconUrl;
     })
 }

 function headerDropDownHandler() {
     let defualtDropDownIconUrl = "https://static.wixstatic.com/shapes/996a4e_e95c51eb6dc54e22ae5b6686b7d0afc2.svg"; //Arrow Down
     let expandedDropDownIconUrl = "https://static.wixstatic.com/shapes/996a4e_c7bb5734f5734e8dbd0f63be7ac7f15b.svg"; //Arrow Up

     $w('#CDBtn').icon = defualtDropDownIconUrl;

     $w('#communityDiscussuions').onClick(() => {
         if ($w('#CDBtn').icon === defualtDropDownIconUrl) {
             $w('#CDRepeaterbox').expand();
             $w('#CDBtn').icon = expandedDropDownIconUrl;
         } else {
             $w('#CDRepeaterbox').collapse();
             $w('#CDBtn').icon = defualtDropDownIconUrl;
         }
     })

     $w('#communityDiscussuions').onMouseIn((e) => {
         console.log(e.target.children)
         $w('#CDRepeaterbox').expand();
         $w('#CDBtn').icon = expandedDropDownIconUrl;

     })

     $w('#communityDiscussuions').onMouseOut(() => {
         $w('#CDRepeaterbox').collapse();
         $w('#CDBtn').icon = defualtDropDownIconUrl;
         $w('#CDBtn').icon = defualtDropDownIconUrl;
     })

 }

 function initMasterSearch() {
     $w('#masterSearchInput').onKeyPress((event) => {
         const value = event.target.value;
         const validateValue = (value.length > 1) && (value.trim() !== '');

         if (validateValue && event.key === 'Enter')
             wixLocation.to(`/forum/search/${value.trim()}`);
     })
     $w('#mobileSearch').onKeyPress((event) => {
         const value = event.target.value;
         const validateValue = (value.length > 1) && (value.trim() !== '');

         if (validateValue && event.key === 'Enter')
             wixLocation.to(`/forum/search/${value.trim()}`);
     })

 }

 export function categoriesHeaderRepeater_itemReady($item, itemData) {
     $item("#repeatedCategoryDeskBtn").label = itemData.name;
     $item("#repeatedCategoryDeskBtn").link = itemData.pageUrl;
 }